import './Badge.scss'

import React from 'react'
import { formatAnalyticsData } from '@bikemap/components/_common/helpers'

/**
 * Badge style element - either read-only or clickable as button or link.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {"primary"|"premium"} [props.variant]
 * @param {React.MouseEventHandler} [props.onClick]
 * @param {string} [props.href]
 * @param {Object} [props.analytics] Analytics properties to attach to DOM element
 */
const Badge = ({ children, variant, onClick, href, analytics }) => {
    const props = {
        className: variant ? ('badge-' + variant) : 'badge',
        ...formatAnalyticsData(analytics),
    }

    if (href) {
        return <a {...props} href={href} onClick={onClick}>{children}</a>
    }

    if (onClick) {
        return <button {...props} onClick={onClick}>{children}</button>
    }

    return <span {...props}>{children}</span>
}

export default Badge
